import { StyledCalendarHeaderCell } from "./calendar-header-cell.styles";
import { IMDSCalendarHeaderCellProps } from "./calendar-header-cell.types";

export function MDSCalendarHeaderCell(props: IMDSCalendarHeaderCellProps) {
  return <StyledCalendarHeaderCell {...props} />;
}
